import { useContext, useState, useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Input } from '../../components'
import { GlobalContext } from '../../contexts/Global'
import * as S from './style'
import 'react-tabs/style/react-tabs.css'
import { ResetPasswordOnReact } from '../../helpers/resetPassword'
import { resetUsername } from '../../helpers/resetUsername'
import { getQueryParams } from '../../helpers'
import { ERROR_MESSAGES } from '../../helpers/errorMessages'
import { toast } from 'react-toastify'

const ForgotDetails = () => {
  const {
    state: { forgotType, isAlternativeActive },
    dispatch,
  } = useContext(GlobalContext)
  const [tabIndex, setTabIndex] = useState()
  const [errors, setErrors] = useState({})
  const [usernameInput, setUsernameInput] = useState('')
  const [vatInput, setVatInput] = useState('')
  const navigate = useNavigate()
  const queryParams = getQueryParams()

  const handleTabChange = useCallback(
    (index, updateUrl) => {
      toast.dismiss()
      const target = index === 0 ? 'password' : 'username'
      dispatch({ type: 'changeForgotType', payload: target })
      if (updateUrl !== false) {
        navigate(
          `/reset-password?${
            isAlternativeActive ? `${target}=1&maggiortutela=1` : `${target}=1`
          }`
        )
      }
    },
    [isAlternativeActive]
  )

  useEffect(() => {
    toast.dismiss()
    const params = getQueryParams()
    if (params.maggiortutela) {
      dispatch({ type: 'changeIsAlternativeActive', payload: true })
    }
    if (params.password) {
      handleTabChange(0, false)
    } else if (params.username) {
      handleTabChange(1, false)
    }
  }, [])

  useEffect(() => {
    if (forgotType === 'password') {
      setTabIndex(0)
    } else if (forgotType === 'username') {
      setTabIndex(1)
    }
  }, [forgotType])

  const validateForm = () => {
    toast.dismiss()
    let value
    let errorKey
    let handler
    document.querySelector('#loader-scripts').classList.add('visible')

    if (forgotType === 'password') {
      value = usernameInput
      errorKey = 'username'
      handler = ResetPasswordOnReact
    } else if (forgotType === 'username') {
      value = vatInput
      errorKey = 'vat'
      handler = resetUsername
    }

    if (value.length > 0) {
      // to replace with new ga4
      handler(value, dispatch, isAlternativeActive)
    } else {
      setErrors({ [errorKey]: ERROR_MESSAGES.required })
      document.querySelector('#loader-scripts').classList.remove('visible')
    }
  }

  return (
    <S.ForgotDetailsWrapper>
      <S.ForgotDetailsContent>
        <S.ForgotDetailsContentTabsContainer>
          {typeof tabIndex !== 'undefined' && (
            <S.TabsStyled selectedIndex={tabIndex} onSelect={handleTabChange}>
              <S.TabListStyled>
                <S.TabStyled isAlternativeActive={isAlternativeActive}>
                  Password Dimenticata
                </S.TabStyled>
                <S.TabStyled isAlternativeActive={isAlternativeActive}>
                  Nome Utente Dimenticato
                </S.TabStyled>
              </S.TabListStyled>
              <S.TabPanelStyled selected={forgotType === 'password'}>
                <S.ForgotDetailsContentDescription>
                  Per modificare la password inserisci il tuo nome utente o
                  l'e-mail di registrazione. Riceverai una e-mail con il link
                  che ti servirà per effettuare la modifica.
                  <br /> Ti ricordiamo che se hai effettuato la registrazione
                  prima del 5/09/2016, per richiedere il recupero password è
                  necessario inserire il nome utente (per esempio: mariorossi) e
                  non l’indirizzo e-mail.
                </S.ForgotDetailsContentDescription>
                <S.ForgotDetailsInputContainer>
                  <Input
                    id="usermail"
                    label="NOME UTENTE O E-MAIL DI REGISTRAZIONE"
                    placeholder="Inserisci il tuo nome utente o e-mail"
                    value={usernameInput}
                    onChange={(e) => setUsernameInput(e.target.value)}
                    smallLabel
                    required
                    forgotDetails
                    errorMessage={errors.username}
                    type="text"
                  >
                    <S.ForgotDetailsInputDescription>
                      I campi contrassegnati con asterisco * sono obbligatori
                      <br />I dati inseriti non vengono riconosciuti?{' '}
                      <button
                        className="anchor-link"
                        onClick={() => handleTabChange(1)}
                      >
                        Recupera il nome utente
                      </button>
                      .
                    </S.ForgotDetailsInputDescription>
                  </Input>
                </S.ForgotDetailsInputContainer>
              </S.TabPanelStyled>
              <S.TabPanelStyled selected={forgotType === 'username'}>
                <S.ForgotDetailsContentDescription>
                  Per recuperare il tuo nome utente inserisci il codice fiscale
                  o la partita IVA indicati in bolletta. Riceverai via e-mail il
                  tuo nome utente corretto.
                </S.ForgotDetailsContentDescription>
                <S.ForgotDetailsInputContainer>
                  <Input
                    id="fiscalcode"
                    label="CODICE FISCALE O PARTITA IVA"
                    placeholder="Inserisci il tuo codice fiscale o Partita Iva"
                    value={vatInput}
                    onChange={(e) => setVatInput(e.target.value)}
                    smallLabel
                    required
                    forgotDetails
                    errorMessage={errors.vat}
                    type="text"
                  >
                    <S.ForgotDetailsInputDescription>
                      I campi contrassegnati con asterisco * sono obbligatori
                      <br />
                    </S.ForgotDetailsInputDescription>
                  </Input>
                </S.ForgotDetailsInputContainer>
              </S.TabPanelStyled>
              {forgotType === 'password' && (
                <S.RecaptchaInfoContainer>
                  <em>
                    Questo sito è protetto da{' '}
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://developers.google.com/recaptcha/docs/v3?hl=it"
                      data-tracked="true"
                    >
                      reCAPTCHA Invisibile (v. 3)
                    </a>{' '}
                    e su di esso si applicano{' '}
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://policies.google.com/privacy?hl=it"
                      data-tracked="true"
                    >
                      l'Informativa sulla privacy
                    </a>{' '}
                    e i{' '}
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://policies.google.com/terms"
                      data-tracked="true"
                    >
                      Termini del servizio
                    </a>{' '}
                    di Google.
                  </em>
                </S.RecaptchaInfoContainer>
              )}
            </S.TabsStyled>
          )}
        </S.ForgotDetailsContentTabsContainer>
      </S.ForgotDetailsContent>
      <S.ForgotDetailsContentErrorContainer id="Error">
        <span />
      </S.ForgotDetailsContentErrorContainer>
      <S.ForgotDetailsButtonsContainer>
        <S.ButtonsFocusContainer>
          <Button
            secondary
            label="Indietro"
            onClick={() => {
              dispatch({ type: 'reset' })
              toast.dismiss()
              navigate(
                `/${queryParams.maggiortutela ? '?maggiortutela=1' : ''}`
              )
            }}
          />
        </S.ButtonsFocusContainer>
        <S.ButtonsFocusContainer>
          <Button label="Continua" onClick={validateForm} />
        </S.ButtonsFocusContainer>
      </S.ForgotDetailsButtonsContainer>
    </S.ForgotDetailsWrapper>
  )
}

export default ForgotDetails
